"use strict";

var _core = require("@emotion/core");

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@emotion/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var foundation_1 = require("../../theme/foundation");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

exports.Checkbox = utils_2.forwardRef(function Checkbox(props, ref) {
  var label = props.label,
      checked = props.checked,
      disabled = props.disabled,
      onClick = props.onClick,
      noMargin = props.noMargin,
      rest = __rest(props, ["label", "checked", "disabled", "onClick", "noMargin"]);

  var _a = React.useState(false),
      isChecked = _a[0],
      check = _a[1];

  var _b = React.useState(false),
      isHover = _b[0],
      setHover = _b[1];

  var defaultStyle = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tborder-radius: 2em;\n\t\tcursor: ", ";\n\t\tbackground-color: transparent;\n\t\tcolor: ", ";\n\t\tborder: none;\n\t\tfont-size: 1em;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 1.25em;\n\t\t", "\n\t"], ["\n\t\tborder-radius: 2em;\n\t\tcursor: ", ";\n\t\tbackground-color: transparent;\n\t\tcolor: ", ";\n\t\tborder: none;\n\t\tfont-size: 1em;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 1.25em;\n\t\t", "\n\t"])), disabled ? 'not-allowed' : 'pointer', foundation_1.colors.black, !noMargin && 'margin-bottom: 1em;');
  var checkboxStyle = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\tbackground-color: ", ";\n\t\tmargin-right: 0.5em;\n\t\tborder: solid 1px ", ";\n\t\tborder-radius: ", ";\n\t\theight: 1.25rem;\n\t\twidth: 1.25rem;\n\t\tfont-size: 0.75em;\n\t\tcursor: ", ";\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t\topacity: ", ";\n\n\t\t&:hover {\n\t\t\tbackground-color: ", ";\n\t\t\tcolor: ", ";\n\t\t\tborder: solid 1px ", ";\n\t\t}\n\t"], ["\n\t\tbackground-color: ", ";\n\t\tmargin-right: 0.5em;\n\t\tborder: solid 1px ", ";\n\t\tborder-radius: ", ";\n\t\theight: 1.25rem;\n\t\twidth: 1.25rem;\n\t\tfont-size: 0.75em;\n\t\tcursor: ", ";\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t\topacity: ", ";\n\n\t\t&:hover {\n\t\t\tbackground-color: ", ";\n\t\t\tcolor: ", ";\n\t\t\tborder: solid 1px ", ";\n\t\t}\n\t"])), (isChecked || checked) && !isHover ? foundation_1.colors.primary.green : foundation_1.colors.white, isChecked || checked ? foundation_1.colors.primary.green : foundation_1.colors.secondary.lightGrey, isChecked || checked ? '1.125em' : '4px', disabled ? 'not-allowed' : 'pointer', isChecked || checked ? foundation_1.colors.white : foundation_1.colors.primary.green, disabled ? '.5' : '1', foundation_1.colors.white, foundation_1.colors.primary.green, isChecked || checked ? foundation_1.colors.primary.green : foundation_1.colors.secondary.lightGrey);
  var checkboxFont = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\tcolor: ", ";\n\t\twidth: 100%;\n\t\theight: 100%;\n\t"], ["\n\t\tcolor: ", ";\n\t\twidth: 100%;\n\t\theight: 100%;\n\t"])), foundation_1.colors.primary.green);
  var checkboxFontWhite = core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\tcolor: ", ";\n\t\twidth: 100%;\n\t\theight: 100%;\n\t"], ["\n\t\tcolor: ", ";\n\t\twidth: 100%;\n\t\theight: 100%;\n\t"])), foundation_1.colors.white);

  var onClickAction = function onClickAction() {
    if (!disabled) {
      check(!isChecked);
    }

    if (onClick) {
      onClick();
    }
  };

  var setMouseEnter = function setMouseEnter() {
    setHover(!isHover);
  };

  var setMouseLeave = function setMouseLeave() {
    if (isHover) {
      setHover(false);
    }
  };

  return (0, _core.jsx)(lseds_1.lseds.div, {
    css: defaultStyle,
    onClick: onClickAction
  }, (0, _core.jsx)(lseds_1.lseds.div, _extends({
    ref: ref
  }, rest, {
    css: checkboxStyle,
    name: name,
    onMouseEnter: function onMouseEnter() {
      return setMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      return setMouseLeave();
    }
  }), isHover && (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: 'check',
    css: checkboxFont
  }), (isChecked || checked) && !isHover && (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: 'check',
    css: checkboxFontWhite
  })), (0, _core.jsx)("div", {
    onMouseEnter: function onMouseEnter() {
      return setMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      return setMouseLeave();
    }
  }, label));
});

if (utils_1.isDev) {
  exports.Checkbox.displayName = 'Checkbox';
}

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;